import React, { useEffect, useRef } from 'react';
import * as echarts from 'echarts';

const ProfitTrendChart = ({ profitData }) => {
  const chartRef = useRef(null);

  useEffect(() => {
    const chart = echarts.init(chartRef.current);

    const data = [
      { name: 'Daily', value: profitData.daily, period: '1 Day' },
      { name: 'Weekly', value: profitData.weekly, period: '7 Days' },
      { name: 'Monthly', value: profitData.monthly, period: '30 Days' }
    ];

    const option = {
      tooltip: {
        trigger: 'axis',
        formatter: function(params) {
          const param = params[0];
          return `${param.name}<br/>Profit: RM${param.value.toLocaleString()}<br/>Period: ${data[param.dataIndex].period}`;
        },
        backgroundColor: 'rgba(255,255,255,0.95)',
        borderColor: '#e2e8f0',
        borderWidth: 1,
        textStyle: { color: '#334155' }
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '10%',
        top: '10%',
        containLabel: true
      },
      xAxis: {
        type: 'category',
        data: data.map(item => item.name),
        axisLine: { lineStyle: { color: '#e2e8f0' } },
        axisTick: { lineStyle: { color: '#e2e8f0' } },
        axisLabel: { color: '#64748b', fontSize: 12 }
      },
      yAxis: {
        type: 'value',
        axisLabel: {
          formatter: 'RM{value}',
          color: '#64748b',
          fontSize: 12
        },
        axisLine: { lineStyle: { color: '#e2e8f0' } },
        splitLine: { lineStyle: { color: '#f1f5f9' } }
      },
      series: [
        {
          data: data.map((item, index) => ({
            value: item.value,
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: item.value >= 0 ? '#10b981' : '#ef4444' },
                { offset: 1, color: item.value >= 0 ? '#059669' : '#dc2626' }
              ]),
              borderRadius: [4, 4, 0, 0]
            }
          })),
          type: 'bar',
          barWidth: '60%',
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0,0,0,0.5)'
            }
          }
        }
      ]
    };

    chart.setOption(option);

    const handleResize = () => {
      chart.resize();
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
      chart.dispose();
    };
  }, [profitData]);

  return (
    <div>
      <div ref={chartRef} style={{ width: '100%', height: '300px' }} />
      <div className="mt-4 text-center text-sm text-slate-600">
        <p>Profit projections based on current daily performance</p>
      </div>
    </div>
  );
};

export default ProfitTrendChart;